export const navigateUrls = {
  home: "/",
  about: "/about-us",
  service: "/services",
  caseStudies: "/case-studies",
  insights: "/insights",
  contact: "/contact-us",
  thankYou: "/thank-you",
};
